module.exports = __webpack_public_path__ + "static/media/Icon material-delete-forever-gris.275a1816.svg";